<template>
  <transition name="fade" mode="out-in" appear>
    <div v-if="success">
      <slot>
        <p>{{ success }}</p>
      </slot>
    </div>
    <div v-else-if="error">
      <slot>
        <p style="color: red">{{ error }}</p>
      </slot>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['success', 'error'],
};
</script>



// WEBPACK FOOTER //
// src/components/Helpers/Alert.vue